import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import AboutEn from './pages/About/AboutEn';
import AboutGr from './pages/About/AboutGr';
import Tournaments from './pages/Tournaments/Tournaments';
import Panellhnio2021 from './pages/Panellhnia/2021/Panellhnio2021';
import Panellhnio2022 from './pages/Panellhnia/2022/Panellhnio2022';
import Panellhnio2023 from './pages/Panellhnia/2023/Panellhnio2023';
import Czech2022 from './pages/Tournaments/tournaments/Czech2022/Czech2022';
import Greek2022 from './pages/Tournaments/tournaments/Greek2022/Greek2022';
import Greek2023 from './pages/Tournaments/tournaments/Greek2023/Greek2023';
import Finland2023 from './pages/Tournaments/tournaments/Finland2023/Finland2023';
import SingaporeSmashEvent2024 from './pages/Tournaments/tournaments/SingaporeSmashEvent2024/SingaporeSmashEvent2024';
import Montenegrin2022 from './pages/Tournaments/tournaments/Montenegrin2022/Montenegrin2022';
import Successes2025 from './pages/Successes/Successes2025';
import Support from './pages/Support/Support';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';

function App() {
  return (
   <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Tournaments" element={<Tournaments />} />
        <Route path="/About" element={<About />} />
        <Route path="/Support" element={<Support />} />
        <Route path="/Panellhnia/Panellhnio2023" element={<Panellhnio2023 />} />
        <Route path="/Panellhnia/Panellhnio2022" element={<Panellhnio2022 />} />
        <Route path="/Panellhnia/Panellhnio2021" element={<Panellhnio2021 />} />
        <Route path="/Tournaments/tournaments/SingaporeSmashEvent2024" element={<SingaporeSmashEvent2024 />} />
        <Route path="/Tournaments/tournaments/Finland2023" element={<Finland2023 />} />
        <Route path="/Tournaments/tournaments/GreekParaOpen2023" element={<Greek2023 />} />
        <Route path="/Tournaments/tournaments/GreekParaOpen2022" element={<Greek2022 />} />
        <Route path="/Tournaments/tournaments/CzechParaOpen2022" element={<Czech2022 />} />
        <Route path="/Tournaments/tournaments/MontenegroParaChanmpionships2022" element={<Montenegrin2022 />} />
        <Route path="/Successes/2025" element={<Successes2025 />} />
      </Routes>
   </BrowserRouter>
  );
}

export default App;
